export default class AdminCreateOrderDto {
    customer;
    paymentMethod;
    customerRemarks;
    internalRemarks;
    ledger;
}
